import { lazy } from 'react'
import { ListOrdered } from 'lucide-react'

import { AGENT_PERMISSIONS, PERMISSION_KEYS } from '@/lib/permissions'
import type { PolicyCreateProps, PolicyKindContribution } from '@/modules/hierarchy'
import { PREFERRED_COUNTER_POLICY_TYPE } from '../../api/preferred-counter-policy-api'
import { PreferredCounterPolicyForm } from './preferred-counter-policy-form'

function CreatePreferredCounterPolicy({ entityId, onClose }: PolicyCreateProps) {
  return <PreferredCounterPolicyForm entityId={entityId} policy={null} onClose={onClose} />
}

export const preferredCounterPolicyKind: PolicyKindContribution = {
  valueType: PREFERRED_COUNTER_POLICY_TYPE,
  label: 'Preferred counters',
  description: 'Choose counter formats and visible counters for new printers.',
  icon: ListOrdered,
  order: 10,
  readPermission: AGENT_PERMISSIONS.read,
  managePermission: PERMISSION_KEYS.printerPolicyManage,
  create: CreatePreferredCounterPolicy,
  list: lazy(() => import('./preferred-counter-policy-list').then((module) => ({ default: module.PreferredCounterPolicyList }))),
}
